import React from 'react';
export function Footer() {
  return <footer className="bg-clinical-base py-8 md:py-10 border-t border-clinical-line" data-id="element-78" data-mp="32wd2qgad7ltj">
      <div className="max-w-[1140px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-79" data-mp="3gg1025qei1yp">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-5 text-center md:text-left" data-id="element-80" data-mp="32oe1fz8zkhcr">
          <div data-id="element-81" data-mp="36qhg0wqyc229">
            <div className="flex items-baseline gap-2 justify-center md:justify-start mb-2" data-id="element-82" data-mp="36pza18ehm9h5">
              <span className="font-bold text-clinical-deep text-base tracking-tight uppercase" data-id="element-83" data-mp="3ugboz385h6h8">
                Atlas Clínico
              </span>
              <span className="text-clinical-mid font-medium text-xs" data-id="element-84" data-mp="3lec768pb9yd8">
                Mega Pack Enfermería
              </span>
            </div>
            <p className="text-clinical-ink/70 text-[13px] max-w-md mx-auto md:mx-0 leading-relaxed" data-id="element-85" data-mp="3qc3zv4xs5oih">
              Material digital de estudio para estudiantes y profesionales de
              enfermería. No reemplaza el criterio profesional ni los protocolos
              de cada institución.
            </p>
          </div>

          <div data-id="element-86" data-mp="3lbmultja1agf">
            <h2 className="font-bold text-clinical-deep mb-2 text-xs tracking-[0.16em] uppercase" data-id="element-87" data-mp="3gagzjp259b3q">
              Contacto
            </h2>
            <p className="text-[13px] text-clinical-ink/70 break-all" data-id="element-88" data-mp="3v8rh5uh1b7xr">
              soportetuvidasimpleok@gmail.com
            </p>
          </div>
        </div>

        <div className="pt-5 mt-5 border-t border-clinical-line flex flex-col md:flex-row justify-between items-center gap-2" data-id="element-89" data-mp="830hxf7jlyyw">
          <p className="text-[11px] text-clinical-ink/50 text-center md:text-left" data-id="element-90" data-mp="34p8h5l5tqh7">
            © Atlas Clínico 2026 — Todos los derechos reservados.
          </p>
          <p className="text-[13px] text-clinical-deep accent-italic text-center md:text-right" data-id="element-91" data-mp="huo8ldw9zbzb">
            Estudiar mejor también es cuidar mejor.
          </p>
        </div>
      </div>
    </footer>;
}